import { levelSelectors, turnSelectors } from '~/store/selectors';

export function getGamePlayStatsForTurn(state) {
    const level = levelSelectors.getLevelNumber(state);
    const turnPhase = turnSelectors.getTurnPhase(state);
    const turnNumber =  turnSelectors.getTurnNum(state);

    const storedTime = JSON.parse(localStorage.getItem('gamePlayTime') || '{"active": 0, "idle": 0}');
    const activeTime = Math.floor(storedTime.active / 1000) ;
    const idleTime = Math.floor(storedTime.idle / 1000) ;

    const totalPlayTime = localStorage.getItem('totalPlayTime');

    return {
        level,
        turnPhase,
        turnNumber,
        activeTime,
        idleTime,
        totalPlayTime,
    };
};

export function resetTimer() {
    localStorage.setItem('shouldRefreshTurnTimer', true);
    localStorage.setItem('gamePlayTime', JSON.stringify({
        active: 0,
        idle: 0,
    }));
}
